import { css } from 'emotion'
import styled from 'react-emotion'
import elevation from './elevation'

export const UnstyledLink = css({ border: 0 });

export const Card = css({
  backgroundColor: '#fff',
  boxShadow: elevation(7),
  display: 'block',
  margin: '0 0 40px',
  textDecoration: 'none',

  h2: {
    fontSize: '1rem',
    margin: 0,
    padding: 15,
  },

  small: {
    color: '#b8b8b8',
    display: 'inline-block',
    fontSize: '.6em',
    letterSpacing: 1,
    textTransform: 'uppercase',

    '&::before': {
      backgroundColor: '#b8b8b8',
      content: '""',
      display: 'inline-block',
      height: '1em',
      margin: '0 10px',
      verticalAlign: 'top',
      width: 1,
    }
  }
})

export const HomepageCard = css(Card, {
  margin: '0 30px 40px',

  h2: {
    fontSize: '1.2rem',
    margin: 0,
    padding: '20px 15px',
  }
})

export const Button = css({
  backgroundColor: '#000',
  border: 0,
  color: '#fff',
  display: 'block',
  fontFamily: '"Raleway"',
  letterSpacing: 2,
  marginTop: 30,
  padding: 10,
  textAlign: 'center',
  textTransform: 'uppercase',
  width: '100%',
})

export const ButtonOutline = css(Button, {
  backgroundColor: 'transparent',
  border: '1px solid #b8b8b8',
  color: '#606060',
})



// WEBPACK FOOTER //
// ./src/utils/styles.js